import { flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";

import { productExportWarehouseBusiness } from "api/bussiness/product/product-export-warehouse-bussiness";
import { productImportWarehouseBusiness } from "api/bussiness/product/product-import-warehouse-bussiness";
import { productWarehouseBussiness } from "api/bussiness/product/product-warehouse-bussiness";
import {
  GetProductsExportWarehouse,
  GetProductsImportWarehouse,
  GetProductsWarehouse,
} from "api/models/request/product-warehouse/get-products-warehouse";
import { Pagination } from "api/models/response/pagination";
import {
  IProductGoodsIssueProperties,
  ProductGoodsIssue,
} from "mobx-stores/_models/product-inventory/product-goods-issue/product-goods-issue";
import { ProductGoodsReceipt } from "mobx-stores/_models/product-inventory/product-goods-receipt/product-goods-receipt";
import {
  IProductInventoryProperties,
  ProductInventory,
} from "mobx-stores/_models/product-inventory/product-inventory";
import { ProductInventoryTab } from "pages/product-inventory/product-inventory";
import { withSetPropAction } from "../_extension/with-set-props";
import { DateRangeFilterStore } from "./common/date-range-filter-store";
import { PaginationStore } from "./common/pagination-store";
export const ProductInventoryQueryParams = types
  .model({
    dealingName: "",
    code: "",
    name: "",
    barcode: "",
  })
  .actions(withSetPropAction);
const ProductInventoryStore = types
  .model({
    productsInventory: types.optional(types.array(ProductInventory), []),
    pagination: types.optional(PaginationStore, {}),
    queryParams: types.optional(ProductInventoryQueryParams, {}),
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    getProductsInventory: flow(function* getProductsInventory(
      request?: GetProductsWarehouse
    ) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            code: self.queryParams.code,
            dealingName: self.queryParams.dealingName,
            name: self.queryParams.name,
            barcode: self.queryParams.barcode,
          };
        }
        const res = (yield productWarehouseBussiness.getProductsWarehouse(
          request
        )) as Pagination<IProductInventoryProperties>;
        self.setProp("productsInventory", res.items);
        self.pagination.setProp("totalItems", res.totalCount);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));

export const ProductGoodsReceiptQueryParams = types
  .model({
    dealingName: "",
    code: "",
    name: "",
    barcode: "",
    dateRangeFilter: types.optional(DateRangeFilterStore, {}),
  })
  .actions(withSetPropAction);
const ProductGoodsReceiptStore = types
  .model({
    productGoodsReceipts: types.optional(types.array(ProductGoodsReceipt), []),
    productGoodsReceiptDetail: types.maybeNull(ProductGoodsReceipt),
    productFilterValue: "",
    pagination: types.optional(PaginationStore, {}),
    openNew: false,
    openEdit: false,
    openDelete: false,
    queryParams: types.optional(ProductGoodsReceiptQueryParams, {}),
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    getProductGoodsReceipt: flow(function* getProductGoodsReceipt(
      request?: GetProductsImportWarehouse
    ) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            filter: self.pagination.filter,
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            fromImportDate:
              self.queryParams.dateRangeFilter.fromAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.from
                ? self.queryParams.dateRangeFilter.from
                : undefined,
            toImportDate:
              self.queryParams.dateRangeFilter.toAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.to
                ? self.queryParams.dateRangeFilter.to
                : undefined,
            dealingName: self.queryParams.dealingName,
            name: self.queryParams.name,
            code: self.queryParams.code,
            barcode: self.queryParams.barcode,
          };
        }
        const res =
          (yield productImportWarehouseBusiness.getLists<GetProductsImportWarehouse>(
            request
          )) as Pagination<IProductGoodsIssueProperties>;
        self.setProp("productGoodsReceipts", res.items);
        self.pagination.setProp("totalItems", res.totalCount);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));

export const ProductGoodsIssueQueryParams = types
  .model({
    dealingName: "",
    code: "",
    name: "",
    barcode: "",
    dateRangeFilter: types.optional(DateRangeFilterStore, {}),
  })
  .actions(withSetPropAction);
const ProductGoodsIssueStore = types
  .model({
    productGoodsIssues: types.optional(types.array(ProductGoodsIssue), []),
    productGoodsIssueDetail: types.maybeNull(ProductGoodsIssue),
    pagination: types.optional(PaginationStore, {}),
    productFilterValue: "",
    openNew: false,
    openEdit: false,
    openDelete: false,
    queryParams: types.optional(ProductGoodsIssueQueryParams, {}),
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    getProductGoodsIssue: flow(function* getProductGoodsIssue(
      request?: GetProductsExportWarehouse
    ) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            filter: self.pagination.filter,
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            sorting: "",
            fromExportDate:
              self.queryParams.dateRangeFilter.fromAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.from
                ? self.queryParams.dateRangeFilter.from
                : undefined,
            toExportDate:
              self.queryParams.dateRangeFilter.toAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.to
                ? self.queryParams.dateRangeFilter.to
                : undefined,
            name: self.queryParams.name,
            code: self.queryParams.code,
            dealingName: self.queryParams.dealingName,
            barcode: self.queryParams.barcode,
          };
        }
        const res = (yield productExportWarehouseBusiness.getLists(
          request
        )) as Pagination<IProductGoodsIssueProperties>;
        self.setProp("productGoodsIssues", res.items);
        self.pagination.setProp("totalItems", res.totalCount);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));

export const ProductInventoryManagement = types
  .model({
    productInventoryStore: types.optional(ProductInventoryStore, {}),
    productGoodsReceiptStore: types.optional(ProductGoodsReceiptStore, {}),
    productGoodsIssueStore: types.optional(ProductGoodsIssueStore, {}),
    tabSelected: types.maybeNull(
      types.enumeration<ProductInventoryTab>(
        "ProductInventoryTab",
        Object.values(ProductInventoryTab)
      )
    ),
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({}));
